import { TransferSearchQuery } from './types'
import { TransferDirection } from '../../types'

const blankTransferSearchQuery: TransferSearchQuery = {
  direction: TransferDirection.ToAirport,
  pickup_datetime: '',
  flight_number: '',

  address_place_id: '',
  address_name: '',
  address_formatted: '',
  address_components: [],
  address_country: '',
  address_lat: '',
  address_lng: '',

  airport_code: '',
  airport_name: '',
  airport_country: '',
  airport_lat: '',
  airport_lng: '',

  connecting_airport_code: '',
  connecting_airport_name: '',
  connecting_airport_country: '',
  connecting_airport_lat: '',
  connecting_airport_lng: '',

  adults: 0,
  children: 0,
  infants: 0,

  luggage_small: 0,
  luggage_large: 0,

  oversized_child_seats: 0,
  oversized_golf_clubs: 0,
  oversized_prams: 0,
  oversized_skis: 0,
  oversized_snowboards: 0,
}

export default blankTransferSearchQuery
